
let fileExplorerProjects = [];

const fileExplorerModifiedAtDescending = "modifiedAtDescending";
const fileExplorerModifiedAtAscending = "modifiedAtAscending";

const fileExplorerNameDescending = "nameDescending";
const fileExplorerNameAscending = "nameAscending";

const fileExplorerMaterialDescending = "materialDescending";
const fileExplorerMaterialAscending = "materialAscending";

const fileExplorerProjectLimit = 1000

let fileExplorerCurrentSortBy = fileExplorerModifiedAtDescending;

function fileExplorerOpenDesign(beamDesignKey) {
    loadProject(beamDesignKey);
    $('#modal-file-explorer-dialog').modal('hide');
    ga('send', 'event', 'File Explorer', 'open', 'Open from File Explorer');
}

function openFileExplorerDialog() {
    $('#modal-file-explorer-dialog').modal('show');
    getBeamDesignsFromDatabaseAndUpdateFileExplorerList()
}

function getBeamDesignsFromDatabaseAndUpdateFileExplorerList() {
  if(firebase.auth().currentUser === null) {
      return;
  }
  var uid = firebase.auth().currentUser.uid;
  firebase.database().ref('projects/' + uid + '/beam-designer')
    .limitToLast(fileExplorerProjectLimit).once('value').then(function(snapshot) {
      fileExplorerProjects = [];
      snapshot.forEach(function(childSnapshot) {
          var childKey = childSnapshot.key;
          var childData = childSnapshot.val();
          var project = BeamProject.load(childData);
          fileExplorerProjects.push(project);
      });
      return updateFileExplorerList()
    });
}

function updateFileExplorerList() {
    sortFileListForFileExplorer();

    let str = '<table class="table">';
    str += '<tr><th><a href="#" onclick="toggleSortFilesByName()">Name</a></th>';
    str += '<th><a href="#" onclick="toggleSortFilesByMaterial()">Material</a></th>';
    str += '<th><a href="#" onclick="toggleSortFilesByLastModified()">Last Modified</a></th>';

    fileExplorerProjects.forEach( p => {
        try {
            str += '<tr style="padding: 6px;" onclick="fileExplorerOpenDesign(\'' + p.key + '\');">';
            //str += '<tr style="padding: 6px;" class="ws-ui-table-row-disable" id="' + p.key + '">';
            str += '<td style="padding: 6px;">' + p.title + '</td>';
            str += '<td style="padding: 6px;">' + p.materialName + '</td>';
            str += '<td style="padding: 6px;">' + timeago().format(p.modifiedAt) + '</td>';
            str += '</tr>';
        } catch(error) {
            console.log(error);
        }
    })
    str += '</table>';
    //console.log(str)
    document.getElementById("file-explorer-table").innerHTML = str;
}

function sortFileListForFileExplorer() {
    switch(fileExplorerCurrentSortBy) {
        case fileExplorerModifiedAtDescending:
            fileExplorerProjects.sort(function(a, b){
                if(a.modifiedAt > b.modifiedAt) { return -1; }
                if(a.modifiedAt < b.modifiedAt) { return 1; }
                return 0;
            });
            return;
        case fileExplorerModifiedAtAscending:
            fileExplorerProjects.sort(function(a, b){
                if(a.modifiedAt < b.modifiedAt) { return -1; }
                if(a.modifiedAt > b.modifiedAt) { return 1; }
                return 0;
            });
            return;
        case fileExplorerNameDescending:
            fileExplorerProjects.sort(function(a, b){
                if(a.title > b.title) { return -1; }
                if(a.title < b.title) { return 1; }
                return 0;
            });
            return;
        case fileExplorerNameAscending:
            fileExplorerProjects.sort(function(a, b){
                if(a.title < b.title) { return -1; }
                if(a.title > b.title) { return 1; }
                return 0;
            });
            return;
        case fileExplorerMaterialDescending:
            fileExplorerProjects.sort(function(a, b){
                if(a.materialName > b.materialName) { return -1; }
                if(a.materialName < b.materialName) { return 1; }
                return 0;
            });
            return;
        case fileExplorerMaterialAscending:
            fileExplorerProjects.sort(function(a, b){
                if(a.materialName < b.materialName) { return -1; }
                if(a.materialName > b.materialName) { return 1; }
                return 0;
            });
            return;
        default: break;
    }
}

let fileExplorerCurrentFileNameSort = fileExplorerNameDescending;
let fileExplorerCurrentMaterialSort = fileExplorerMaterialDescending;
let fileExplorerCurrentFileModifiedAtSort = fileExplorerModifiedAtDescending;

function toggleSortFilesByName() {
    if(fileExplorerCurrentFileNameSort === fileExplorerNameAscending) {
        fileExplorerCurrentFileNameSort = fileExplorerNameDescending;
    } else {
        fileExplorerCurrentFileNameSort = fileExplorerNameAscending;
    }
    fileExplorerCurrentSortBy = fileExplorerCurrentFileNameSort;
    updateFileExplorerList();
}

function toggleSortFilesByMaterial() {
    if(fileExplorerCurrentMaterialSort === fileExplorerMaterialAscending) {
        fileExplorerCurrentMaterialSort = fileExplorerMaterialDescending;
    } else {
        fileExplorerCurrentMaterialSort = fileExplorerMaterialAscending;
    }
    fileExplorerCurrentSortBy = fileExplorerCurrentMaterialSort;
    updateFileExplorerList();
}

function toggleSortFilesByLastModified() {
    if(fileExplorerCurrentFileModifiedAtSort === fileExplorerModifiedAtAscending) {
        fileExplorerCurrentFileModifiedAtSort = fileExplorerModifiedAtDescending;
    } else {
        fileExplorerCurrentFileModifiedAtSort = fileExplorerModifiedAtAscending;
    }
    fileExplorerCurrentSortBy = fileExplorerCurrentFileModifiedAtSort;
    updateFileExplorerList();
}
